import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import Text, { styles as textStyles } from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Animated, { useAnimatedStyle, useSharedValue, } from 'react-native-reanimated';
import { AnimatedTextInput } from 'design-system/AnimatedComponents';
const DateInputField = ({ title, placeholder, maxLength, value, error, onDark, onChangeText, onSubmitEditing, onKeyPress, autoComplete, ref, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const focused = useSharedValue(false);
    const onBlur = useCallback(() => focused.set(false), [focused]);
    const onFocus = useCallback(() => {
        focused.set(true);
        const max = maxLength || 4;
        ref.current?.setSelection?.(max, max);
    }, [focused, maxLength, ref]);
    const animatedStyle = useAnimatedStyle(() => {
        if (error) {
            return {
                borderColor: colors.text.negative,
            };
        }
        if (!focused.get())
            return {
                borderColor: onDark ? colors.cards.onDark : colors.cards.onLight,
            };
        return {
            borderColor: colors.text.brand,
        };
    }, [
        colors.cards.onDark,
        colors.cards.onLight,
        colors.text.brand,
        colors.text.negative,
        error,
        focused,
        onDark,
    ]);
    const animatedInputStyle = useAnimatedStyle(() => {
        if (error) {
            return {
                color: colors.text.negative,
            };
        }
        if (!focused.get())
            return {
                color: colors.text.tertiary,
            };
        return {
            color: colors.text.brand,
        };
    }, [
        colors.text.brand,
        colors.text.negative,
        colors.text.tertiary,
        error,
        focused,
    ]);
    return (<View style={styles.container}>
      <Text Text-16>{title}</Text>
      <Animated.View style={[
            styles.containerInput,
            onDark && styles.containerInputOnDark,
            title === 'Year' && styles.year,
            animatedStyle,
        ]}>
        <AnimatedTextInput value={value} ref={ref} keyboardType="numeric" allowFontScaling={false} placeholder={placeholder} onChangeText={onChangeText} onKeyPress={onKeyPress} autoComplete={autoComplete} importantForAutofill="yes" onBlur={onBlur} onFocus={onFocus} selectionColor={colors.text.selection} placeholderTextColor={colors.text.tertiary} onSubmitEditing={onSubmitEditing} style={[styles.textInput, animatedInputStyle]}/>
      </Animated.View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignItems: 'center',
        marginHorizontal: rem(12),
    },
    containerInput: {
        marginTop: 5,
        width: rem(58),
        borderWidth: 1,
        height: rem(56),
        borderRadius: rem(12),
        overflow: 'hidden',
        backgroundColor: colors.cards.onLight,
    },
    containerInputOnDark: {
        backgroundColor: colors.cards.onDark,
    },
    textInput: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        ...textStyles.Text_24,
    },
    year: {
        width: rem(74),
    },
}));
export default memo(DateInputField);
